$(document).ready(function(){

	// -- toggle hamburger menu --
	$('.header__hamburger button').on('click', function(){
		$('body').toggleClass('menus--open');
		$(this).toggleClass('is-active');
	});
	
  // -- animations on hover --
  $(".hover\\:btn--underline").on('mouseover', function(){
    $(this).removeClass('underline-rtl').addClass('underline-ltr');
  });
  $(".hover\\:btn--underline").on('mouseleave', function(){
    $(this).removeClass('underline-ltr').addClass('underline-rtl');
  });

	// -- close menu when click outside header --
  $(document).mouseup(function(e){
    var container = $('.header');
    if (!container.is(e.target) && container.has(e.target).length === 0){
  		$('body').removeClass('menus--open');
			$('.hamburger').removeClass('is-active');
    }
	});

});